export default {
  async getSubscription(subscriptionId, email) {
    const response = await fetch(
      `${import.meta.env.VITE_SERVER_URL}/get-subscription`,
      {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Origin: `${window.location.origin}`,
        },
        body: JSON.stringify({
          subscription_id: subscriptionId,
          email: email, // billing_email
        }),
      },
    );
    return response;
  },

  async checkout(user, variant, couponCode) {
    const response = await fetch(
      `${import.meta.env.VITE_SERVER_URL}/checkout`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Origin: `${window.location.origin}`,
        },
        body: JSON.stringify({
          payload: {
            data: {
              type: "checkouts",
              attributes: {
                checkout_options: {
                  embed: true,
                },
                checkout_data: {
                  ...(user?.email && { email: user?.email }),
                  ...(user?.displayName && { name: user?.displayName }),
                  ...(couponCode && { discount_code: couponCode }),
                  custom: {
                    variant_id: variant,
                    ...(user?.email && { email: user?.email }),
                  },
                },
              },
              relationships: {
                store: {
                  data: {
                    type: "stores",
                    id: import.meta.env.VITE_LEMONSQUEEZY_STORE_ID,
                  },
                },
                variant: {
                  data: {
                    type: "variants",
                    id: variant,
                  },
                },
              },
            },
          },
        }),
      },
    );
    return response;
  },
};
